export default __webpack_public_path__ + "static/media/CCTVPicture.583e9c56.jpg";